import React from 'react'
import './LoginScreen.css'
import { useState } from 'react'
import SignupScreen from './SignupScreen'
function LoginScreen() {

const [signin, setSignin] = useState(false)

const currentYear = new Date().getFullYear();






  return (
    <div className='loginScreen'>

    <div className='loginscreen_background'>
        <img className='loginscreen_logo' src='https://assets.stickpng.com/images/580b57fcd9996e24bc43c529.png' alt=""/>

        <button onClick={() => setSignin(true)} className='loginscreen_button'>
            Sign In
        </button>

        <div className='loginscreen_gradient' />
    </div>
    <div className='loginscreen_body'>

    {signin ? (<SignupScreen />) : (

        <>
            <h1>Unlimited films, TV programmes and more.</h1>
            <h2>Watch anywhere. Cancel at any time!</h2>
            <h3>Ready to watch? Enter email to create or restart your membership</h3>

            <div className='loginscreen_input'>
                <form>
                    <input type="email" placeholder='Email address' />
                    <button onClick={() => setSignin(true)} className='loginscreen_getstarted'>GET STARTED</button>
                </form>
            </div>
         
        </>

    )}


    </div>

    <h4 style={{ textAlign: 'center', backgroundColor: 'white', padding:'10px' }}>Made with ❤️ by Dami</h4>
    <h4 style={{ textAlign: 'center',  backgroundColor: 'white', }}>&copy; {currentYear}</h4>
    </div>
  )
}

export default LoginScreen